import S from '../Main.template.style';
import { PageLayoutContent } from './Content/PageLayoutContent';
import { PageLayoutProvider } from './Context/PageLayoutContext';
import type { IPageLayoutRight } from './types/PageLayoutRight.types';

const PageLayoutRight = ({ children, footerText, id }: IPageLayoutRight) => {
  return (
    <PageLayoutProvider footerText={footerText}>
      <S.RightContainer id={id}>
        <PageLayoutContent id={id}>{children}</PageLayoutContent>
      </S.RightContainer>
    </PageLayoutProvider>
  );
};

export { PageLayoutRight };
